import UploadImg from "./index.vue"

/* istanbul ignore next */
UploadImg.install = function (Vue) {
  Vue.component(UploadImg.name, UploadImg)
}
 
export default UploadImg